import { GetInTouch } from "../components/pages/getInTouch";

export function GetInTouchPage(){

    return(
        <>
            <GetInTouch />
        </>
    );
}